


























import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";
import { SpecialCareValue } from "../store/types";
import ButtonRadio from "./button-radio.vue";

@Component({
  components: { ButtonRadio }
})
export default class extends Vue {
  @Prop({ default: -1 })
  public value!: number;

  @Emit("change")
  private changed(value: number) {
    return value;
  }
}
